
































































/* General */
import Vue from 'vue'
import * as routerNames from '@/services/router/router.names'
import {
  ContentPlaceholders,
  ContentPlaceholdersText,
} from 'vue-content-placeholders'

/* Mixins */

/* Components */

/* Helpers */
import LocalStore from '@/helpers/localstore'
import RouteAssistant from '@/helpers/route-assistant'

/* Data types */
import { StatusTypeValues } from '@/types'

/* API */
import DashboardAPI from '@/api/modules/dashboard.api'
import { IDashboardOutputDashboardItem } from '@/api/types/response.types'

export default Vue.extend({
  name: 'DashboardPinboard',

  components: {
    ContentPlaceholders,
    ContentPlaceholdersText,
  },

  data() {
    return {
      StatusTypeValues,
      pinnedItems: [] as IDashboardOutputDashboardItem[],
      routerNames,
      isLoading: true,
      navPanels: [],
      pinboardHidden: false,
    }
  },

  computed: {
    hasPinnedItems(): boolean {
      return this.pinnedItems.length > 0
    },
    togglePinboardLabel(): string {
      return this.pinboardHidden ? 'Show your pinboard' : 'Hide'
    },
    togglePinboardIcon(): string {
      return this.pinboardHidden ? 'ddi-caret-down' : 'ddi-caret-up'
    },
    hasNonSamplePinnedItems(): boolean {
      return (
        this.hasPinnedItems &&
        this.pinnedItems.some(
          p => !this.$permissions.isSampleInternalProjectID(p.entity.id),
        )
      )
    },
    showMailboxes(): boolean {
      return this.$permissions.isNotGuest
    },
  },

  async created() {
    try {
      this.pinboardHidden = LocalStore.dashboardHidePinboard
      this.isLoading = true
      await this.getPinnedItems()
      this.isLoading = false
    } catch (error) {
      this.$error.emit(error)
    }
  },

  methods: {
    async getPinnedItems() {
      try {
        const response = await DashboardAPI.get_PinnedItems()
        this.pinnedItems = response.listItems
      } catch (error) {
        this.$error.emit(error)
      }
    },
    async removePinnedItem(item: IDashboardOutputDashboardItem) {
      try {
        this.pinnedItems = this.pinnedItems.filter(pi => pi.id !== item.id)
        await DashboardAPI.delete_DeletePinnedItem(item.id)
      } catch (error) {
        this.$error.emit(error, true)
        this.getPinnedItems()
      }
    },
    limitedCountText(count: number): string {
      return count < 100 ? `${count}` : '99+'
    },
    togglePinboard() {
      this.pinboardHidden = !this.pinboardHidden
      LocalStore.dashboardHidePinboard = this.pinboardHidden
    },
    getItemRoute(item: IDashboardOutputDashboardItem) {
      if (item.isConversation) {
        return RouteAssistant.getConversationRoute(
          this.$route.params.accountId,
          item.entity.id,
          item.id,
          item.entity.name,
          item.refNumber,
          item.title,
        )
      } else {
        return RouteAssistant.getTaskRoute(
          this.$route.params.accountId,
          item.entity.id,
          item.id,
          this.$permissions,
          item.entity.name,
          item.refNumber,
          item.title,
        )
      }
    },
  },
})
